import React, { useEffect, useState } from "react"
import { enumUtil } from "../../../../utils/Enum"
import FormValidator from "../../../../utils/FormValidator"
import { ServerRequestProtected } from "../../../../utils/ServerDataRequest"
import NotificationHandler from "../../../../utils/NotificationHandler"
import isNull from "../../../../utils/NullChecking"
import Loader from "../../../shared/Loader/Loader"
import Modal from 'react-bootstrap/Modal';
import DeleteConfirmatiom from "../../../General/DeleteConfirmation"
import Audit from "../../../General/Audit"
import ModalHeader from "../../Shared/ModalHeader"
import ModalFooter from "../../Shared/ModalFooter"
import { FindSecondChild } from "../../../../utils/FindMenuOption"
const AddNewModifier = (props) => {
    let IsEditAllowed = FindSecondChild('Setup', 'Codes', 'Modifiers')?.IsAdd
    let IsDeleteAllowed = FindSecondChild('Setup', 'Codes', 'Modifiers')?.IsDeleted
    let valModal = {}
    // validation modal 
    let ValidationModal = {
        ModifierCodeVal: "",
    }

    let Modifier_Modal = {
        // PracticeID: 113,
        ModifierCode: null,
        Description: "",
        FullDescription: "",
        UpdatedDate: "",
        UpdatedBy: ""
    }
    const [ModifierCodes, setModifierCodes] = useState()
    const [ModifierValidationModal, setModifierValidationModal] = useState(ValidationModal)
    const [ModifierSaveUpdateModal, setModifierSaveUpdateModal] = useState({})
    const [mainModifierModal, setmainModifierModal] = useState(Modifier_Modal);
    const [isLoading, setIsLoading] = useState(false)
    const [del, setDel] = useState(false)
    const [isOpenAlert, setisOpenAlert] = useState(false);
    const API_URL = enumUtil.controller.General
    const { isOpenModifier, onClose, onDeleteModifier, type, isOpenFromList, handleSelectModofier } = { ...props }
    const [onModifierSave, setOnModifierSave] = useState(false)
    const [isOpenAudit, setisOpenAudit] = useState(false);


    useEffect(() => {
        if (props.ModifierCode != null && !isOpenFromList) {
            setModifierCodes(props.ModifierCode)
            setDel(true);
        } else {
            if (!onModifierSave) {
                setModifierCodes(0);
                setDel(false);
            } else {
                setDel(true);
            }

        }
    }, [])
    useEffect(() => {
        if (!isNull(ModifierCodes) && !isOpenFromList) {
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/FindByID", 'post', {
                "ID": ModifierCodes,
                "TableName": enumUtil.enumAPITableName.Modifier

            }).then((response) => {
                setIsLoading(false)
                setmainModifierModal(response)
                // setPracticeID(response.PracticeID)
            }).catch((error) => {
                setIsLoading(false)
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                setIsLoading(false)
            })
        }
    }, [ModifierCodes])

    useEffect(() => {
        if (isOpenFromList) {
            setmainModifierModal({ ...mainModifierModal, ModifierCode: props.ModifierCode })
            setModifierSaveUpdateModal({ ...ModifierSaveUpdateModal, ModifierCode: props.ModifierCode })
        }
    }, [isOpenFromList])

    const handleModifierChange = (e) => {
        let { name, value } = e.target;
        if (process.env.REACT_APP_ISUPPERCASE === "true") {
            value = value.toUpperCase()
        }
        let modal = { ...mainModifierModal };
        let saveModal = { ...ModifierSaveUpdateModal }
        modal[name] = value
        setmainModifierModal(modal)
        for (var property in Modifier_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setModifierSaveUpdateModal(saveModal)
    }
    const ModifierValidation = async () => {
        let ValidationModal = {
            ModifierCodeVal: FormValidator(
                mainModifierModal.ModifierCode,
                enumUtil.enumValidationType.Required,
                'Modifier Code',
            )
        }
        await setModifierValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    const handleSaveModifier = async () => {
        setModifierCodes(mainModifierModal.ModifierCode)
        setModifierCodes(ModifierCodes)
        await ModifierValidation()
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            setModifierSaveUpdateModal(ModifierSaveUpdateModal)
            let saveModal = {
                TableName: enumUtil.enumAPITableName.Modifier,
                ID: ModifierCodes,
                data: { ...ModifierSaveUpdateModal },
                value: null
            }
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal)
                .then((response) => {
                    // console.log("response", response)
                    if (!isNull(response.id)) {
                        setIsLoading(false)
                        onDeleteModifier()
                        NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
                        handleSelectModofier({ display: mainModifierModal.ModifierCode, value: response.id })
                        setModifierCodes(response.id)
                        setOnModifierSave(true)
                    }
                }).catch((error) => {
                    setIsLoading(false)
                    console.log('error', error);
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                })
        }
    }
    const SetModifierName = () => {
        if (mainModifierModal.ModifierCode != null && mainModifierModal.ModifierCode != "") {
            return (
                <p className="heading">{mainModifierModal.ModifierCode}</p>
            )
        } else {
            return (
                <p className="heading">Add New Modifier Code</p>
            )
        }
    }
    const handleDeleteModal = () => {
        setisOpenAlert(true)
    }
    const onCloseDelete = () => {
        setisOpenAlert(false)
    }
    let DeletePopup = ""
    if (del) {
        DeletePopup = <button className={IsDeleteAllowed === false ? 'btn-icon-transparent delete-btn-disabled' : 'btn-icon-transparent '} onClick={handleDeleteModal}><span className="icon"><i className="icon-delete"></i></span><span className="title">Delete</span></button>
    }
    let DeleteConfirmation = "";
    if (isOpenAlert) {
        DeleteConfirmation = <DeleteConfirmatiom isOpenAlert={isOpenAlert} onCloseDelete={onCloseDelete} API_URL={API_URL} TableName={enumUtil.enumAPITableName.Modifier} ID={ModifierCodes} onClose={onDeleteModifier} />
    }
    const handleAuditModal = () => {
        setisOpenAudit(true)
    }
    const onCloseAudit = () => {
        setisOpenAudit(false)
    }
    let AuditPopup = "";
    if (isOpenAudit) {
        AuditPopup = <Audit isOpenAudit={isOpenAudit} onCloseAudit={onCloseAudit} ParentID={ModifierCodes + ""} TableName={enumUtil.enumAPITableName.Modifier} />
    }
    const AddNewModifierModalBody = () => {
        return (
            <>
                {isLoading ? <Loader /> : null
                }
                <div>
                    <div className="form-group input">
                        <label htmlFor="ModifierCode">Modifier Code<span className='req'>*</span></label>
                        <div className={ModifierValidationModal.ModifierCodeVal ? 'form-group input error' : 'form-group input'}>
                            <input type="text"
                                className='form-control'
                                name="ModifierCode"
                                id="ModifierCode"
                                autoComplete="off"
                                value={mainModifierModal.ModifierCode}
                                onChange={handleModifierChange}
                            />
                            {ModifierValidationModal.ModifierCodeVal}
                        </div>
                        {/* error helperText="Error Message" */}
                    </div>
                    <div className='form-group input'>
                        <label htmlFor="Description">Description</label>
                        <input type="text"
                            className='form-control'
                            name="Description"
                            id="Description"
                            autoComplete="off"
                            value={mainModifierModal.Description}
                            onChange={handleModifierChange}
                        />
                    </div>
                    <div className='form-group input'>
                        <label htmlFor="FullDescription">Full Description</label>
                        <textarea type="text"
                            rows={5}
                            className='form-control'
                            name="FullDescription"
                            id="FullDescription"
                            value={mainModifierModal.FullDescription}
                            onChange={handleModifierChange}
                        />
                    </div>
                </div>
            </>
        )
    }
    return (
        <React.Fragment>
            {DeleteConfirmation}
            {type && type === "Wizard" ?
                <>
                    {AuditPopup}
                    <div className="px-10 pb-15">
                        {AddNewModifierModalBody()}
                    </div>
                    <ModalFooter isSaved={onModifierSave ? onDeleteModifier : onClose} handleSave={handleSaveModifier} UpdatedDate={mainModifierModal.UpdatedDate} UpdatedBy={mainModifierModal.UpdatedBy} ID={ModifierCodes} IsEditAllowed={IsEditAllowed} />
                </>
                :
                <Modal show={isOpenModifier} onHide={onClose} backdrop="static" keyboard={false} centered dialogClassName="app-modal hk-modal-v1 ar-small-modal">
                    {AuditPopup}
                    <Modal.Body>
                        <ModalHeader HeaderName={SetModifierName} isOpenAudit={isOpenAudit} handleAuditModal={handleAuditModal} DeletePopup={DeletePopup} isClosed={onModifierSave ? onDeleteModifier : onClose} key={635} Name={'Modifiers'} IsDeleteAllowed={IsDeleteAllowed} />
                        {AddNewModifierModalBody()}
                    </Modal.Body>
                    <ModalFooter isSaved={onModifierSave ? onDeleteModifier : onClose} handleSave={handleSaveModifier} UpdatedDate={mainModifierModal.UpdatedDate} UpdatedBy={mainModifierModal.UpdatedBy} ID={ModifierCodes} IsEditAllowed={IsEditAllowed} />
                </Modal>
            }
        </React.Fragment>
    )
}

export default AddNewModifier